<template>
  <div class="wrapper">
    <div class="logo">
      <img @click="onBlockscan" id="logo" src="~@/assets/logo.gif" alt="PLA" />
    </div>
    <div class="login-form-container">
      <p class="page-form-title">Register a New Account</p>
      <p class="page-form-tip">Fill out the form to get started.</p>
      <el-form
        class="login-form"
        ref="form"
        :model="form"
        :rules="rules"
        label-position="top"
      >
        <el-form-item label="Username:" prop="username">
          <el-input
            name="username"
            v-model="form.username"
            :disabled="isLoading"
            placeholder="Username has to be from 5 to 30 characters in length."
          ></el-input>
        </el-form-item>

        <el-form-item label="Public key:" prop="publicKey">
          <el-input
            name="publicKey"
            v-model="form.publicKey"
            :disabled="isLoading"
            placeholder="Please enter the public key."
          />
        </el-form-item>
        <el-form-item>
          <p class="is-tips">
            Already have an account? Click to
            <router-link to="/login">log in</router-link>.
          </p>
          <p class="is-tips">
            Or visit the
            <router-link to="/dashboard/block-scan-page"
              >Block Scan</router-link
            >
            directly.
          </p>
        </el-form-item>
        <el-form-item class="login-button-container">
          <el-button
            class="login-button fullwidth"
            type="primary"
            @click="onSubmit"
            :loading="isLoading"
          >
            REGISTER
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import cachedInfo from '../util/global'

export default {
  name: 'login',

  data() {
    return {
      isLoading: false,
      form: {
        username: '',
        publicKey: ''
      },
      rules: {
        username: [
          {
            required: true,
            message: 'Please enter username.',
            trigger: 'change'
          },
          {
            pattern: /^[a-z_0-9]{5,30}$/,
            message: 'Username has to be from 5 to 30 characters in length.',
            trigger: 'change'
          }
        ],
        publicKey: [
          {
            required: true,
            message: 'Please enter public key.',
            trigger: 'change'
          },
          {
            pattern: /^[A-Za-z0-9]{64}$/,
            message: 'Public key has to be 64 characters in length.',
            trigger: 'change'
          }
        ]
      },
      cachedInfo
    }
  },

  methods: {
    onBlockscan() {
      this.$router.push({ name: 'block-scan-page' })
    },
    onSubmit() {
      this.$refs['form'].validate((valid) => {
        if (!valid) return false

        this.isLoading = true
        this.onRegister()
      })
    },
    onRegister() {
      this.$axios({
        method: 'post',
        url: `/api/users/${this.form.username}@${this.cachedInfo.userNode}`,
        params: {
          public_key: this.form.publicKey
        }
      })
        .then((response) => {
          this.isLoading = false
          this.$message({
            showClose: true,
            message: `The registration is submitted successfully, please wait for the administrator's approval.`,
            type: 'success'
          })
          setTimeout(() => {
            this.$refs['form'].resetFields()
            this.isLoading = false
          }, 500)
        })
        .catch((error) => {
          this.isLoading = false
          const err = error.data.error
          let errString = ''
          for (let i in err) {
            errString += `${i}: ${err[i]}. `
          }

          this.$message({
            showClose: true,
            message: `Registration failed. ${errString}`,
            type: 'error',
            duration: 5000
          })
        })
    }
  }
}
</script>

<style lang="scss">
.wrapper {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-self: center;
  min-height: 100vh;
}
.login-form-container {
  margin: auto;
}
.page-form-title {
  font-weight: bold;
  color: #333;
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
}
.page-form-tip {
  color: #aaa;
  margin-bottom: 2rem;
  font-size: 0.75rem;
}
.logo {
  display: flex;
  justify-content: center;
  background: #333;
}
.logo img {
  display: block;
  margin: 0 auto;
  height: 4rem;
  margin: 1rem;
  border-radius: 8px;
  cursor: pointer;
}
.login-form {
  width: 25rem;
  justify-content: center;
}
.is-tips {
  color: #999;
  margin-bottom: -15px;
  a {
    text-decoration: underline;
  }
}
</style>
